export default {
  header: {
    notes: 'Header for parts search page',
    message: 'Search parts',
  },
  results: {
    notes: 'Subheader for search results page',
    message: 'Results',
  },
  empty: {
    text: {
      notes: 'Empty state for parts search',
      message: 'Search for parts in the field above',
    },
  },
  emptyNoMatch: {
    text: {
      notes: 'Empty state when no parts match the search query',
      message: 'No parts match your search',
    },
  },
  overLimitMatches: {
    notes:
      'Help text (little i) that are displayed if the number of search hits is over a specific limit',
    message:
      'Your search generated {{limit}} or more matches. Please use a more specific search query to narrow your search.',
  },
};
